import { FormikProps } from 'formik'

export function resetForm(form: FormikProps<any>) {
  form.resetForm()
  form.validateForm()
}
